import React from 'react';
import PropTypes from 'prop-types';
import I18n from '../../components/i18n';
import Button from '../../components/button';
import authProvider from '../../auth/auth0-provider';
import config from '../../config';

const DEFAULT_ERROR_MESSAGE = 'error.generic';

export default function Error(props) {
  const onErrorBackButtonClick = React.useCallback(() => {
    if (config?.launchpad?.uiUrl) {
      window.location = config.launchpad.uiUrl;
    } else {
      authProvider.getContext().forceInteractiveLogin();
    }
  }, []);
  const error =
    props?.customMessage || props?.match?.params?.id || props?.location?.state?.error || DEFAULT_ERROR_MESSAGE;

  return (
    <div className="error-view">
      <div className="title">
        <img className="logo" src={`${process.env.PUBLIC_URL}/images/vht_logo.svg`} alt="VHT" />
        <span>
          <I18n t="error-view.title" />
        </span>
      </div>

      <p>
        <I18n t={error} />
      </p>

      <div>
        <Button variant="primary" onClick={onErrorBackButtonClick}>
          <I18n t="error-view.back-button" />
        </Button>
      </div>
    </div>
  );
}

Error.propTypes = {
  /** The location passed by react-router */
  location: PropTypes.object,
  /** An I18n error key */
  customMessage: PropTypes.string,
};
